<template>
    <div class="campsite__choice-icon" @click.stop="openCampingCardAcsiInfo()">
      <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" width="18" height="18" >
        <g fill="#000" fill-rule="nonzero">
          <path d="M10.533 20.694a10.165 10.165 0 1 1 10.161-10.16c-.008 5.608-4.552 10.152-10.16 10.16zm0-18.852a8.691 8.691 0 1 0 8.688 8.691 8.698 8.698 0 0 0-8.688-8.69z"></path>
          <circle cx="10.533" cy="7.07" r="1.179"></circle>
          <path d="M9.616 9.155h1.813v6.016H9.616z"></path>
        </g>
      </svg>
    </div>
</template>

<script>
import { CiCampingCareAcsiInfoModal } from '@/components'

export default {
  name: 'CiCampingCareAcsiInfo',
  components: {
    CiCampingCareAcsiInfoModal,
  },
  props: {
    campground: {
      type: Object,
      required: true,
    },
    currency: {
      type: Object,
      required: true,
    },
    language: {
      type: Object,
      required: false,
    },
  },
  computed: {
    campingcardAcsiInfo() {
      return this.$store.getters['campground/campingcardAcsiInfo']
    },
  },
  methods: {
    openCampingCardAcsiInfo() {
      const settings = {
        adaptive: true,
        clickToClose: true,
        height: 'auto',
        maxWidth: 800,
        pivotY: 0.5,
        scrollable: true,
        width: '100%',
      }

      const { currency, ...yearlyAcsiInfo } = this.campingcardAcsiInfo || {}
      const campingcardAcsiInfoArray = Object.entries(yearlyAcsiInfo).map(
        ([year, data]) => ({
          year,
          ...data,
          currency,
        })
      )

      this.$modal.show(
        CiCampingCareAcsiInfoModal,
        {
          title: this.$t('pages.campingCardACSIInfo.headline'),
          campgroundName: this.campground.name,
          content: campingcardAcsiInfoArray,
          currency: this.currency,
          language: this.language,
        },
        settings,
        {}
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.campsite__choice-icon {
  height: 18px;
  width: 18px;
  position: relative;
  top: -7px;
  cursor: pointer;
}
.campsite__inner--disabled .campsite__choice-icon {
  opacity: 0.5;
  cursor: default;
}
</style>
